import type { ReceiptTemplate } from '../schema';

export const chevronTemplate: ReceiptTemplate = {
  id: 'chevron',
  name: 'Chevron Gas Receipt',
  brand: 'CHEVRON',
  description: 'Chevron gas station receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'chevron-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/chevron.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chevron-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 2:45 PM\nPUMP #6',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'chevron-fuel',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'product', label: 'SUPREME', value: '', isBold: false, isLarge: false },
          { id: 'gallons', label: 'GALLONS', value: '14.238', isBold: false, isLarge: false },
          { id: 'ppg', label: 'PRICE/GAL', value: '4.299', isBold: false, isLarge: false },
          { id: 'total', label: 'FUEL TOTAL', value: '61.21', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'chevron-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'AUTH:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'chevron-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'TECHRON ADDITIVE\n\nTHANK YOU\nPLEASE COME AGAIN',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

